import React from 'react';
import styled from '@emotion/styled';
import { MaybeCognitoError } from '@move-frontend/auth';
import { SignUpErrorMessage } from '../../../../../auth/sign-up/ui/form/SignUpErrorMessage';
import { ErrorBar } from '../../../../../shared/components';

interface IErrorProps {
	error: MaybeCognitoError;
}

export const SignUpError = ({ error }: IErrorProps) => (
	<StyledSignUpError>
		<SignUpErrorMessage error={error} />
	</StyledSignUpError>
);

const StyledSignUpError = styled(ErrorBar)`
	margin-bottom: 24px;
`;
